import ServiceExec from '@/common/utils/ServiceExec';
import { faq } from '@/common/service/apiList';

export default {
  getFaqList: async function({ commit, getters }) {
    const condition = getters['getCondition'];
    const { data, status } = await ServiceExec.get(faq.getList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (condition.page > pageInfo.totalPage) return false;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setFaqList', list ?? []);
  },
  async getDetail({ commit, getters, state }, faqNo) {
    console.log(faqNo);
    const { data, status } = await ServiceExec.get(faq.getDetail + faqNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  }
};
